// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__XTO4Q","summary":"CartItem_summary__HsVHS","price":"CartItem_price__2d4Jg","amount":"CartItem_amount__jGc6p","actions":"CartItem_actions__PtvMp"};